// combatpro/panels/monsters/studio/MonsterStudioCollections.js
//
// Combat PRO - MonsterStudioCollections (Stage 57: Library Runtime Foundation).
//
// Renders the #vi-st-collections content - the React equivalent of the legacy
// viStudioRenderCollections (battletracker.html 11460-11467). When the runtime
// reports no collections it shows the "No collections yet..." message; otherwise it
// renders a label and one chip per collection (name + count), with the active
// collection highlighted. Clicks route to onToggle(name). The runtime owns the
// collection data and the toggle behaviour; this component only renders. No DOM
// access, no manual HTML. No optional chaining. No em dash.

import React from 'react';

function MonsterStudioCollections(props) {
  var cols = Array.isArray(props.collections) ? props.collections : [];

  if (cols.length === 0) {
    return (
      <div className="vi-st-collections" id="vi-st-collections">
        <div className="vi-st-col-empty">No collections yet. Add them on the Identity tab.</div>
      </div>
    );
  }

  return (
    <div className="vi-st-collections" id="vi-st-collections">
      <div className="vi-st-col-label">Collections</div>
      {cols.map(function(c) {
        var cls = 'vi-st-colchip' + (props.activeCollection === c.name ? ' is-active' : '');
        return (
          <button className={cls} type="button" key={c.name} onClick={function() { props.onToggle(c.name); }}>
            {c.name} <span>{c.count}</span>
          </button>
        );
      })}
    </div>
  );
}

export default MonsterStudioCollections;
